<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/26ez6Y/tc-custom/9781439670958.jpg?1694033238211" alt="This image is the cover for the book The Ghostly Tales of Charleston, Spooky America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Ghostly Tales of Charleston, Spooky America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Ghost stories from America's Holy City have never been so creepy, fun, and full of mystery!</b></p><p>Charleston's haunted history and local legends come to life--even when the main players are dead. From the dire warnings of the Gray Man of Pawley's Island, to the long-dead cadets who have never left the original Citadel, this spooky chapter book will keep readers rapt. Dive into suspenseful tales of bumps in the night, paranormal investigations, and the unexplained; just be sure to keep the light on.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allison Singer
      </h2>
      
      <p class="authorDescription body article"><p>Allison Singer is an experienced children's book editor and author from Hillsborough, NJ. She has edited books for publishers including DK and Penguin Random House, and has written a number of nonfiction titles for kids. In her current role as a Senior Editor at TIME, Allie develops content for the magazine's classroom product. Allie is currently based in Brooklyn, NY, where she spends her time reading, drinking tea, and planning adventures.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing/The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1cf04014